<template>
    <div>
        <swb-query-sort-area name="query-sort-area" ref="query_sort_area" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :queryHandler="queryHandler" :popupHandler="popupHandler"></swb-query-sort-area>
        <swb-result-table name="result_table" :confKey="confKey" :onConfigReady="onConfigReady" :configAuto="true" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :height="tableHeight" ref="result_table" :needPager="true" :rowNoShow="false" :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher } from '../../app.vues'
    import { getDefaultPageSizes } from '../../../src/app.conf'
    import { getDevcGroupNameByCatId } from '../index'
    //
    import shopStuffApi from '../../api/shopStuff'
    import assetApi from '../../api/asset'
    import SwbResultTable from '../query/ResultTable'
    Vue.regist(SwbResultTable);
    export default {
        name: 'swb-shop-device-batch-stock-lowcost-list-select',
        desc: '批次库存-选择',
        props: {
            selectIds: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            },
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            checkedIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            selectioned: {
                type: Boolean,
                default: false
            }
        },

        data: function () {
            return {
                confKey: 'swb-shop-device-batch-stock-lowcost-list-select',
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                shopDeviceBatchStockList: [],
                //排序、搜索
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                acctEnterWayMap: {},
                seprPeriodStateMap: {},
                assetKindList: [],
                //
                tableState: [],
                checkStateValue: 0,
                //
                showQuery: true,
                checkState: false,
                //
                lowCostFlag: false,
                showTable: null,
                durable: true,
                clear: false,
                scrap: false,
                showBatch: false,
                queryOnLoad: true,
                metaColList: [],
                tableHeight: 500, //表格高度
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                //
            }
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            thisEl.addClass("overFlow-hidden");
            this.initResultTable();
            //
            self.handleInitChecked();
        },
        beforeDestroy() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        created: function () {
            if(this.selectioned) {
                this.multiSelect = true;
            } else {
                this.multiSelect = false;
            }

            this.pageSize = this.pageSizes.first();

            this.acctEnterWayMap = getEnumMap("acctEnterWay", "value2text");
            this.seprPeriodStateMap = getEnumMap("seprPeriodState", "value2text");
        },
        methods: {
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getShopDeviceBatchStockList();
            },
            initResultTable(){
                let self = this;
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                let query_sort_area = this.$refs['query_sort_area'];
                resultTable.setQrySortRef(query_sort_area);
//                resultTable.setColConfRef(this.querySortArea);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{

                    'devcGroup': function (row, colName, colValue, rowIndex, colConf) {
                        let cat = self.getDevcGroupNameByCatId(row.catId)
                        if(cat != null) {
                            return ' <span>' + cat + '</span>';
                        }
                    },
                    'skuId': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue == -1) {
                            return '<span class="font-green" >是</span>';
                        } else {
                            return '<span>否</span>';
                        }
                    },
                    'imageUrl': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.imageUrl != null) {
                            return '<img style="height: 36px;width: 36px" src="' + row.imageUrl + '"/>';
                        }
                    },

                    'acctEnterWay': function (row, colName, colValue, rowIndex, colConf) {
                        let acctEnterWay = self.acctEnterWayMap[colValue];
                        if(acctEnterWay != null) {
                            return '<span>' + acctEnterWay + '</span>';
                        }
                    },
                    'rmnWorthRatio': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue == null && colValue > 0) {
                            return '<span>' + colValue.toFixed(2) + '</span>';
                        } else {
                            return '<span>0.00</span>';
                        }
                    },
                    'orgWorth': function (row, colName, colValue, rowIndex, colConf) {

                        if(colValue == null && colValue > 0) {
                            return '<span>' + colValue.toFixed(2) + '</span>';
                        } else {
                            return '<span>0.00</span>';
                        }
                    },
                    'netWorth': function (row, colName, colValue, rowIndex, colConf) {

                        if(colValue == null && colValue > 0) {
                            return '<span>' + colValue.toFixed(2) + '</span>';
                        } else {
                            return '<span>0.00</span>';
                        }
                    },
                    'deprPeriod': function (row, colName, colValue, rowIndex, colConf) {
                        let deprPeriod = self.seprPeriodStateMap[colValue];
                        if(deprPeriod != null) {
                            return '<span>' + deprPeriod + '</span>';
                        }
                    },
                });
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                console.log(resultTable.getSelection());
                return resultTable.getSelection();
            },
            getDevcGroupNameByCatId(catId){
                return getDevcGroupNameByCatId(catId);
            },
            // 分页切换
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);

                let resultTable = this.$refs.result_table;
                console.log(resultTable.getPagination());

                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getShopDeviceBatchStockList();
            },
            getShopDeviceBatchStockList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                let filterItem = Object.assign(filterItems, self.filter);
                postData.filterItems = filterItem;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                shopStuffApi.getShopLowCostStuffList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        self.shopDeviceBatchStockList = result.data.rows || [];
                        self.totalCount = result.data.pagination.totalCount;

                        self.renderTable(result.data.rows, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 渲染数据
            renderTable(rows, pagination) {
                //let resultColConfCmp = this.$refs['result_col_conf'];
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                // let confColList = resultColConfCmp.getMetaColList();
                //resultTable.initMeta(confColList);
                let dataMap = {
                    pagination: pagination,
                    rows: rows
                };
                //设置新数据
                resultTable.render(dataMap);
            },
            //回显数据处理
            handleInitChecked() {
                let selectioned = this.selectioned == null ? true : this.selectioned;
                if(selectioned) {
                    let initChecked = this.selectIds;
                    let resultTable = this.$refs.result_table;
                    resultTable.setInitChecked(initChecked, true);
                } else {
                    let initChecked = this.checkedItem;
                    let resultTable = this.$refs.result_table;
                    resultTable.setInitChecked(initChecked);
                }
            },
            getDlgResult: function () {
                let result = {};
                //
                let selectioned = this.selectioned == null ? true : this.selectioned;
                if(!selectioned) {
                    let checkedItem = this.getTableSelection() || null;
                    if(Utils.isNoB(checkedItem) || Utils.isNoB(checkedItem.id)) {
                        result.type = "warn";
                        result.message = "请选择耗材信息";
                        return result;
                    }
                    result.type = "info";
                    result.checkedId = checkedItem.id || null;
                    result.data = checkedItem;
                    return result;
                } else {
                    let selectionList = this.getTableSelection() || null;
                    if(selectionList != null) {
                        result.type = "info";
                        result.data = selectionList;
                        return result;
                    } else {
                        result.type = "warn";
                        result.message = "请选择耗材信息";
                        return result;
                    }
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceBatchStockListLowCostForSelect.vue